export const DEFAULT_GROUP_TYPE = 'BANK_ACCESS'
export const DEFAULT_VIEW_ITEMS = 'VIEW_ITEMS'
export enum EXPIRATION_TYPE {
  DOES_NOT_EXPIRE = 1,
  EXPIRE_X_MINUTES = 2,
  EXPIRE_X_DAYS = 3,
}
